var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0296 0.453796C12.4245 -0.151265 11.4464 -0.151265 10.8414 0.453796L10.1673 1.12793L12.8721 3.83275L13.5462 3.15862C14.1513 2.55356 14.1513 1.57551 13.5462 0.970448L13.0296 0.453796ZM4.76314 6.53204C4.5946 6.70058 4.46475 6.90779 4.39015 7.13711L3.57235 9.59051C3.49223 9.82811 3.55578 10.0906 3.7326 10.2702C3.90942 10.4498 4.17189 10.5105 4.41226 10.4304L6.86566 9.61261C7.09221 9.53801 7.29942 9.40816 7.47072 9.23963L11.9355 4.76935L9.23065 2.06453L4.76314 6.53204ZM2.65233 1.62248C1.18802 1.62248 0 2.8105 0 4.2748V11.3477C0 12.812 1.18802 14 2.65233 14H9.7252C11.1895 14 12.3775 12.812 12.3775 11.3477V8.69535C12.3775 8.20632 11.9824 7.81124 11.4934 7.81124C11.0044 7.81124 10.6093 8.20632 10.6093 8.69535V11.3477C10.6093 11.8367 10.2142 12.2318 9.7252 12.2318H2.65233C2.1633 12.2318 1.76822 11.8367 1.76822 11.3477V4.2748C1.76822 3.78578 2.1633 3.3907 2.65233 3.3907H5.30465C5.79368 3.3907 6.18876 2.99561 6.18876 2.50659C6.18876 2.01756 5.79368 1.62248 5.30465 1.62248H2.65233Z",
    fill: "#279CAA",
    fillOpacity: 0.41
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.585c1cba5a3aa8725f5f24159625eb2b.svg";
export { ForwardRef as ReactComponent };